import { useRef } from 'react';
import { formatFileSize } from '../utils/ticketFiles';
import './ReplyFiles.css';

// "Attach files" control for a reply form: a button, the chosen files as
// removable chips, and an inline error. The parent owns the file list and
// does the upload when the reply is sent.
export default function ReplyFiles({ files, error, disabled, onAdd, onRemove }) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    onAdd(e.target.files);
    e.target.value = '';
  };

  return (
    <div className="reply-files">
      <input ref={inputRef} type="file" multiple hidden onChange={handleChange} />
      <button type="button" className="reply-files-add" disabled={disabled} onClick={() => inputRef.current?.click()}>
        <i className="fas fa-paperclip" aria-hidden="true"></i> Attach files
      </button>
      {files.map((file, i) => (
        <span key={`${file.name}-${i}`} className="reply-files-chip">
          <span className="reply-files-name" title={file.name}>{file.name}</span>
          <span className="reply-files-size">{formatFileSize(file.size)}</span>
          <button type="button" aria-label={`Remove ${file.name}`} disabled={disabled} onClick={() => onRemove(i)}>&times;</button>
        </span>
      ))}
      {error && <p className="reply-files-error" role="alert">{error}</p>}
    </div>
  );
}
